import { render, staticRenderFns } from "./MapCategories.vue?vue&type=template&id=185a3bf4&scoped=true"
import script from "./MapCategories.vue?vue&type=script&lang=js"
export * from "./MapCategories.vue?vue&type=script&lang=js"
import style0 from "./MapCategories.vue?vue&type=style&index=0&id=185a3bf4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185a3bf4",
  null
  
)

export default component.exports